<template>
  <div>
    <MemberLayout>
      <div class="container">
        <div class="card my-2" v-if="isLoaded">
          <div class="card-header bg-primary text-white">付款成功</div>
          <ul class="list-group list-group-flush">
            <li class="list-group-item">
              <p>訂單編號: {{ cart.jselloutCode }}</p>
              <p>
                總金額:
                {{ cart.amount }} NTD
              </p>
              <p>識別碼: {{ recTradeId }}</p>
              <p>收件人：{{ cart.deliver.receiveName }}</p>
              <p>電話號碼：{{ cart.deliver.tel }}</p>
              <p>郵遞區號：{{ cart.deliver.zip }}</p>
              <p>縣市地區：{{ cart.deliver.address1 }}</p>
              <p>地址：{{ cart.deliver.address2 }}</p>
              <p>訂購日期：{{ cart.receptDate }}</p>
            </li>
            <li
              v-for="(item, idx) in getCartItems"
              :key="idx"
              class="list-group-item"
            >
              <p class="font-weight-bold">
                <span v-if="item.SAMPLEFLG === 1">[贈品]</span>
                {{ item.data.NAME }}
              </p>
              <div class="d-flex justify-content-between mt-2">
                <p>
                  $ &nbsp; {{ getNumberWithCommas(item.data.UNITPRICE) }} NTD
                </p>
                <p>x &nbsp; {{ item.amount }} 件</p>
              </div>
            </li>
          </ul>
        </div>

        <div v-if="!isLoaded">
          <Loading />
        </div>
      </div>
    </MemberLayout>
  </div>
</template>
<script>
// 測試網址
// http://localhost:8080/login?cart_id=araIQnTdI3gWEZ4oY5gD&rec_trade_id=D202110050A04IQ
import Loading from "../../components/Loading.vue";
import MemberLayout from "../../components/member/MemberLayout";
import { getCurrentUser, getBusinessMonth } from "../../api/fordaysHelpers";
import { getNumberWithCommas } from "../../api/fordaysHelpers";
import db from "../../api/db";
export default {
  name: "OrderFinishedScreen",
  components: {
    MemberLayout,
    Loading,
  },
  data() {
    return {
      cartDocId: null,
      paymentData: null,
      recTradeId: null,
      jselloutCode: null,
      isLoaded: false,
      user: {},
      month: null,
      cart: {
        items: {},
      },
    };
  },
  computed: {
    getCartItems() {
      const vm = this;
      let items = [];
      for (let x in vm.cart.items) {
        const item = vm.cart.items[x];
        items.push(item);
      }
      return items;
    },
  },
  mounted() {
    const vm = this;
    const cartDocId = vm.$route.params["cart_id"];
    const recTradeId = vm.$route.params["rec_trade_id"];
    vm.cartDocId = cartDocId;
    vm.recTradeId = recTradeId;
    async function fetchData() {
      const user = await getCurrentUser();
      const businessMonth = getBusinessMonth();
      db.collection("appCarts")
        .doc(cartDocId)
        .get()
        .then((cartDoc) => {
          const cart = cartDoc.data();
          vm.user = user;
          vm.isLoaded = true;
          vm.month = businessMonth;
          vm.cart = cart;
          // vm.axios
          //   .post(
          //     "https://fordays-backend-official.herokuapp.com/payment-api/v1/lockCart",
          //     {
          //       cartId: cartDocId,
          //       cart,
          //     }
          //   )
          //   .then((res) => {
          //     console.log("[Locked CART]", res);
          //   })
          //   .catch((err) => {
          //     console.log("[Locked CART ERROR]", err);
          //   });
        })
        .catch((err) => {
          alert(`資料載入錯誤[20001]，資料來源:${cartDocId}`, err);
        });
    }
    fetchData();
  },
  methods: {
    getNumberWithCommas(val) {
      return getNumberWithCommas(val);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>